import { Button } from '@warp-ds/react/components/button';
import { useState } from 'react';
import { HotelPageSearchForm } from '@/components/HotelPageSearchForm';
import { HotelFilterPreview } from '@/components/hotel/HotelFilterPreview';

export const HotelEditPanel = () => {
    const [expanded, setExpanded] = useState(false);

    return (
        <div className="flex justify-between md:p-20 border-b pb-16 md:border md:rounded-8" data-testid="editPanel">
            <div className={`${expanded ? 'hidden' : 'grow'} flex flex-row md:text-m`} data-testid="editPanel-preview">
                <HotelFilterPreview />
                <div className="flex flex-col justify-end md:justify-center">
                    <Button
                        link
                        id="editButton"
                        aria-label="Endre søk"
                        onClick={(): void => setExpanded(true)}
                        className="font-bold text-s md:text-m leading-s md:leading-l">
                        Endre søk
                    </Button>
                </div>
            </div>
            <div className={!expanded ? 'hidden' : 'grow'} data-testid="editPanel-content">
                <h2 className="sr-only">Alternativer for avreise og hjemreise</h2>
                <HotelPageSearchForm onSubmit={() => setExpanded(false)} />
            </div>
        </div>
    );
};
